module.exports = __webpack_public_path__ + "static/media/zepf.3bd9ab44.png";